var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{attrs:{"text-xs-center":""}},[_c('footer',[_c('b',[_c('small',[_vm._v("© Copyright 2019-20 Diptanshu Kakwani")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }